const getEuCountryList = () => ['at', 'be', 'bg', 'hr',
  'cr', 'cz', 'dk', 'ee', 'fi', 'fr', 'de', 'hu', 'ie',
  'it', 'lv', 'lt', 'lu', 'mt', 'aw', 'pl', 'pt', 'ro',
  'sk', 'is', 'es', 'se'];

export const isEuMember = (countryCode) => {
  return getEuCountryList().indexOf(countryCode?.toLowerCase()) !== -1;
};
